<style scoped>

.configure-item {
    width: 250px
}

</style>

<template>

<el-card id="configure" class="box-card">
    <div slot="header" class="clearfix">
        <span style="font-size:22px;" class="el-card-text">常规任务奖励设置</span> <span style="margin-left:10px;color:red;">兑换比例：1000汽车币=1元，以下每项都输入汽车币整数值！</span>
    </div>
    <el-form ref="form" :model="form" label-width="250px">
        <el-row class="basic-margin">
            <el-col :span="20">
                <el-form-item label="新人福利奖励：" prop="newPeopleReward" >
                    <el-input-number v-model="form.newPeopleReward" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="每天登录汽车网奖励：" class="configure-item" prop="everyDayLoginReward" >
                    <el-input-number v-model="form.everyDayLoginReward" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="每有效推荐1位亲友购车奖励：" class="configure-item" prop="recommendRelativesReward">
                    <el-input-number v-model="form.recommendRelativesReward" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="每邀请1位新人注册后奖励：" class="configure-item" prop="recommendNewPeopleReward">
                    <el-input-number v-model="form.recommendNewPeopleReward" :min="0"></el-input-number>
                </el-form-item>
              <el-form-item label="邀请好友奖励数量上限：" class="configure-item" prop="inviteMaxCount">
                    <el-input-number v-model="form.inviteMaxCount" :min="0"></el-input-number>
                </el-form-item>

                <el-form-item label="每次分享汽车网奖励：" class="configure-item" prop="shareReward">
                    <el-input-number v-model="form.shareReward" :min="0"></el-input-number>
                </el-form-item>
								<el-form-item label="每日分享汽车网奖励上限：" class="configure-item" prop="shareMaxReward">
                    <el-input-number v-model="form.shareMaxReward" :min="0"></el-input-number>
                </el-form-item>

            </el-col>
        </el-row>

        <el-form-item>
            <el-button type="primary" @click="validateFrom('form',saveConfirm)">确认修改</el-button>
        </el-form-item>
    </el-form>

</el-card>

</template>

<script>

import coinModel from '@/framework/models/coinModel'
import BasicPager from '@/mixins/BasicPager'
export default {
  name: 'car-coin-configure',
  extends: BasicPager,
  data: function () {
    return {
      form: {
        newPeopleReward: 0,
        everyDayLoginReward: 0,
        shareReward: 0,
        recommendRelativesReward: 0,
        recommendNewPeopleReward: 0,
        inviteMaxCount: 0,
        shareMaxReward: 0
      }
    }
  },
  created: function () {
    this.loadList()
  },
  methods: {
    saveConfirm: function () {
      let _this = this
      this.$confirm('马上要修改配置了, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.save()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消添加'
        })
      })
    },
    loadList: function () {
      let _this = this
      let listener = {
        success: function (dataInfo) {
          if (dataInfo.datas) {
            _this.form = dataInfo.datas
          }
        }
      }
      coinModel.selectTaskConfig(this, listener)
    },
    save: function () {
      let _this = this
      let param = {
        newPeopleReward: _this.form.newPeopleReward,
        everyDayLoginReward: _this.form.everyDayLoginReward,
        shareReward: _this.form.shareReward,
        recommendRelativesReward: _this.form.recommendRelativesReward,
        recommendNewPeopleReward: _this.form.recommendNewPeopleReward,
        shareMaxReward: _this.form.shareMaxReward,
        inviteMaxCount: _this.form.inviteMaxCount
      }
      let listener = {
        success: function (dataInfo) {
          if (dataInfo.success) {
            _this.$message({
              type: 'success',
              message: `修改成功！`
            })
            _this.loadList()
          }
        }
      }
      coinModel.saveTaskConfig(this, param, listener)
    }
  }
}

</script>
